/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const a=(...l)=>{const t={},c=e=>typeof e=="object"?Object.keys(e).forEach(s=>{t[s]=e[s]}):t[e]=!0,r=e=>e.filter(s=>s!==!0&&!!s).map(s=>Array.isArray(s)?r(s):c(s));return r(l),Object.keys(t).map(e=>t[e]&&e||null).filter(e=>e!==null).join(" ")},o=(...l)=>a(l).replace(/[^[\]a-zA-Z0-9-_!: ]/g,"");exports.classNames=a;exports.strippedClassNames=o;
